




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import _ from "lodash";
import Api from "@/store/surelockApi";
import { getInstance } from "@/auth/authPlugin";
import { SURELOCK_SCOPES, PRESERVATION_STATUSES } from "@/utils/constants";
import preservations from "@/store/modules/preservations";
import EditPreservation from "@/components/surelock/EditPreservation.vue";
import PreservationModel from '@/models/PreservationModel';

@Component({
  components: {
    EditPreservation,
    FontAwesomeIcon,
  },
})
export default class PreservationRecordList extends Vue {
  @Prop({ default: [] }) rows!: Array<any>;
  @Prop({ default: 10 }) pageSize!: number;

  loading = false;
  currentPage = 1;
  perPage = 10;

  createUser = false;
  retrievalUser = false;

  loadingId = '';
  processedRecords: any = {};

  fields = [
    {
      key: 'id',
    },
    {
      key: 'description',
    },
    {
      key: 'created',
      sortable: true,
    },
    {
      key: 'status',
      sortable: true,
    },
    {
      key: 'sent',
    },
    {
      key: 'show_details',
      label: '',
    },
  ];

  statuses = ['ANY', 'SUCCESSFUL', 'PROCESSING', 'ERROR', 'CLOSED', 'DELETED'];

  async mounted(): Promise<void> {
    const authService = getInstance();
    this.retrievalUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.RETRIEVE_PRESERVATION
    );
    this.createUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.CREATE_PRESERVATION
    );
  }

  displayedRows(): Array<any> {
    const fields = this.fields.map(field => field.key);
    return this.rows.map((row) => _.pick(row, fields));
  }

  get filteredStatus(): string {
    return preservations.filteredStatus;
  }

  get hasPrevPage(): boolean {
    return !!preservations.olderHref;
  }

  async loadOlderPreservations(): Promise<void> {
    const previousLength = preservations._values.length;
    const previousLastPage = Math.ceil(this.rows.length / this.perPage);
    const wasOnLastPage = this.currentPage === previousLastPage;
    this.loading = true;
    try {
      await preservations.getPrevPreservations();
      await this.$nextTick();
      const loaded = preservations._values.length - previousLength;
      this.$toasted.show(`Loaded ${loaded} older records`, { position: 'top-left', duration: 3000 });
      const newLastPage = Math.ceil(this.rows.length / this.perPage);
      if (wasOnLastPage && this.currentPage === previousLastPage && newLastPage > previousLastPage) {
        this.currentPage = previousLastPage + 1;
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load older records';
      this.$toasted.error(message, { position: 'top-left', duration: 3000 });
    } finally {
      this.loading = false;
    }
  }

  updateStatusFilter(status: string): void {
    preservations.updateStatusFilter(status);
  }

  async showDetails(row: any): Promise<void> {
    const id = _.get(row, 'item.id');
    if (!id || !this.retrievalUser) {
      return;
    }

    if (row.item._showDetails) {
      row.toggleDetails();
      return;
    }

    this.loadingId = id;

    try {
      const data = await Api.getProcessedRecords(id);
      this.processedRecords[id] = data.preservations;
    } catch (err) {
      this.$toasted.error(err, {
        duration: 3000,
      });
      return;
    } finally {
      this.loadingId = '';
    }

    row.toggleDetails();
  }

  displayStatus(preservation: PreservationModel): string {
    if (preservation && preservation.status) {
      if (preservation.status === PRESERVATION_STATUSES.SUCCESSFUL && preservation.videosInTimespan === 0) {
        return PRESERVATION_STATUSES.NO_RECORDINGS;
      }

      return preservation.status;
    }

    return '';
  }

  showUpdateModal(row: any): void {
    const editModal = this.$refs.edit as EditPreservation;
    editModal.showModal(row, async () => {
      await preservations.getPreservations();
    });
  }

  isEmpty(): boolean {
    return _.isNil(this.rows) || this.rows.length === 0;
  }
}
